export type NestedListT = (string | NestedListT)[]

const NestedList = (props: { paraphs: NestedListT }) => {

    const buildList = (paraphs: NestedListT, depth: number = 0) =>
        paraphs.map((x, i) => {
            if (typeof x === "string")
                return (
                    <li key={i} className={depth === 0 ? "mt-1.5" : "mt-1"}>
                        <span className={`mr-1.5 align-middle ${depth === 0 ?
                            "text-accent" : "text-mutedLight dark:text-mutedDark"}`}>
                            {depth === 0 ? "•" : "–"}
                        </span>
                        {x}
                    </li>
                )
            return <ul key={i} className={"pl-4"}>{buildList(x, depth + 1)}</ul>
        })

    return (
        <ul className={"w-full"}>
            {buildList(props.paraphs)}
        </ul>
    )
}

export default NestedList
